import { loginURL } from "../api/client";

/** Why the last sign-in came back without one, as the callback reports it. */
const FAILURE: Record<string, string> = {
  denied: "La connexion a été annulée sur Discord.",
  expired: "La connexion a pris trop de temps. Réessayez.",
  failed: "La connexion avec Discord a échoué. Réessayez.",
};

/** Discord's mark, in the single colour the button uses. */
function DiscordLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden fill="currentColor">
      <path d="M20.32 4.37a19.8 19.8 0 0 0-4.89-1.52.07.07 0 0 0-.08.04c-.21.38-.44.87-.61 1.25a18.27 18.27 0 0 0-5.49 0 12.6 12.6 0 0 0-.62-1.25.08.08 0 0 0-.08-.04 19.74 19.74 0 0 0-4.89 1.52.07.07 0 0 0-.03.03C.53 9.05-.32 13.58.1 18.06a.08.08 0 0 0 .03.06 19.9 19.9 0 0 0 5.99 3.03.08.08 0 0 0 .08-.03c.46-.63.87-1.3 1.23-1.99a.08.08 0 0 0-.04-.11 13.1 13.1 0 0 1-1.87-.89.08.08 0 0 1-.01-.13l.37-.29a.07.07 0 0 1 .08-.01c3.93 1.79 8.18 1.79 12.06 0a.07.07 0 0 1 .08.01l.37.29a.08.08 0 0 1-.01.13c-.6.35-1.22.65-1.87.89a.08.08 0 0 0-.04.11c.36.7.77 1.36 1.22 1.99a.08.08 0 0 0 .08.03 19.84 19.84 0 0 0 6-3.03.08.08 0 0 0 .03-.06c.5-5.18-.84-9.67-3.55-13.66a.06.06 0 0 0-.03-.03ZM8.02 15.33c-1.18 0-2.16-1.08-2.16-2.42 0-1.33.96-2.42 2.16-2.42 1.21 0 2.18 1.1 2.16 2.42 0 1.34-.96 2.42-2.16 2.42Zm7.97 0c-1.18 0-2.15-1.08-2.15-2.42 0-1.33.95-2.42 2.15-2.42 1.21 0 2.18 1.1 2.16 2.42 0 1.34-.95 2.42-2.16 2.42Z" />
    </svg>
  );
}

/**
 * Asks somebody to sign in. Replays belong to an account, so nothing can be
 * uploaded or opened by id without one; only a share link works without.
 */
export function SignIn({
  next = "/",
  available,
  failure,
  reason,
}: {
  /** Where to come back to once signed in. */
  next?: string;
  /** False when the server has no Discord application configured. */
  available: boolean;
  /** The callback's report on a sign-in that did not work, if any. */
  failure?: string | null;
  /** Why signing in is asked for here, when it is not the library. */
  reason?: string;
}) {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center rounded-xl border border-white/10 bg-white/[0.03] px-8 py-10 text-center">
      <p className="text-sm opacity-70">
        {reason ??
          "Connectez-vous pour envoyer vos replays. Ils ne sont visibles que par vous, et par ceux à qui vous donnez un lien de partage."}
      </p>
      {available ? (
        <a
          href={loginURL(next)}
          className="mt-6 flex items-center gap-2 rounded-lg bg-[#5865F2] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#4752c4]"
        >
          <DiscordLogo />
          Se connecter avec Discord
        </a>
      ) : (
        <p className="mt-6 text-sm text-amber-400">
          La connexion Discord n'est pas configurée sur ce serveur (DISCORD_CLIENT_ID et
          DISCORD_CLIENT_SECRET).
        </p>
      )}
      {failure && FAILURE[failure] && (
        <p className="mt-4 text-sm text-red-400">{FAILURE[failure]}</p>
      )}
    </div>
  );
}
